/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ILabPrescription } from 'app/shared/model/lab-prescription.model';
import { IPatientProcedureOrder } from 'app/shared/model/patient-procedure-order.model';

export interface IPatientProcedureInvestigation {
  id?: string;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  labPres?: ILabPrescription;
  order?: IPatientProcedureOrder;
}

export const defaultValue: Readonly<IPatientProcedureInvestigation> = {
  active: false,
};
